import { api } from "../api";

/**
 * activateInterestPointCrudRequest - Function that activates an interest point
 * /interest-points/{customerId}/{interestPointId}/{status}
 * method PUT
 * @async-function
 */
const activateInterestPointCrudRequest = async (
    token: string,
    customerId: number,
    interestPointId: number
) => {
    const response = await api.put(
        `/interest-points/${customerId}/${interestPointId}/activated`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default activateInterestPointCrudRequest;
